function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.532 52.439c-14.463-29.362 7.34-29.592-1.113-48.936 0 0 3.611 2.004 12.03 1.925 8.42-.079 11.778-1.925 11.778-1.925-8.453 19.345 13.351 19.574-1.112 48.936 0 0-3.347 2.56-10.792 2.56S17.53 52.44 17.53 52.44z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.311 12.067s-8.567-2.447-9.68 3.67c-1.112 6.117 6.342 8.564 6.342 8.564"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.066 14.075s-6.704-2.007-7.385 2.37c-.681 4.379 4.849 5.533 4.849 5.533M38.337 12.067s8.567-2.447 9.68 3.67c1.112 6.117-6.342 8.564-6.342 8.564"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.582 14.075s6.704-2.007 7.385 2.37c.681 4.379-4.849 5.533-4.849 5.533"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.14 3C18.083 1.561 23.8 1 28.451.96S38.48 1.618 40.423 3M17.9 7.8c1.669 1.237 6.58 1.718 10.576 1.753S37.091 8.988 38.76 7.8M15.56 47.8c2.027 2.479 8.093 3.445 12.947 3.514 4.854.068 10.566-1.133 12.593-3.514"
})));

var SvgVase = function SvgVase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Vase.91d543eb.svg";
export { ForwardRef as ReactComponent };